import i from 'icepick'

const initialState = {
  complete: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_TO_HOME/MARK_AS_COMPLETE':
      return i.assoc(state, 'complete', true)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/AddToHome/AddToHome.reducer.js